import _ from "lodash";
import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Icon,
  Message,
  Segment,
  Header,
} from "semantic-ui-react";
import {
  getNativeTemplate,
  updateNativeTemplate,
  createNativeTemplate,
} from "../../firebase";
import { ApiRequest } from "../../firebase/server";
import "./retailers.css";

const Selectors = ({ retailer, id, tdata }) => {
  const obj = {
    icon: "",
    title: "",
    width: "",
  };
  const [selectors, setSelectors] = useState([obj]);
  const [templateData, setTemplateData] = useState({});
  const [templateExists, setTemplateExists] = useState();
  const [disabled, setDisabled] = useState(true);
  const [showMessage, setShowMessage] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showSyncMessage, setShowSyncMessage] = useState(false);
  const [showSyncLoading, setShowSyncLoading] = useState(false);
  const [isNative, setIsNative] = useState(false);
  const [customSnippet, setCustomSnippet] = useState();
  const templateId = retailer.templates[id].name;
  const templateType = retailer.templates[id].type;
  const service = retailer.templates[id].service;

  useEffect(() => {
    getNativeTemplate(retailer.name, templateId).then((template) => {
      if (template) {
        setTemplateExists(true);
        if (template.selectors) {
          setSelectors(template.selectors);
          setTemplateData(template);
        }
      } else {
        setTemplateExists(false);
      }
    });
  }, [retailer, templateId]);

  useEffect(() => {
    if (tdata) {
      const { isNativeEligible, snippet } = tdata.result[0];
      setIsNative(isNativeEligible);
      if (!isNativeEligible) setCustomSnippet(snippet);
    }
  }, [tdata]);

  const addSelector = () => {
    setSelectors((prevState) => [...prevState, obj]);
  };

  const removeSelector = (id) => {
    const arr = _.filter(selectors, (selector, index) => {
      return index !== id;
    });
    setSelectors(arr);
  };

  const handleChange = (e, id) => {
    const values = selectors.map((item, i) => {
      if (id === i) return { ...item, [e.target.name]: e.target.value };
      return item;
    });
    setSelectors(values);
    if (disabled) setDisabled(false);
  };

  const handleSubmit = () => {
    setShowLoading(true);
    const data = { ...templateData, selectors };
    if (templateExists) {
      updateNativeTemplate(retailer.name, templateId, data).then(() => {
        setShowMessage(true);
        setDisabled(true);
        setShowLoading(false);
      });
    } else {
      createNativeTemplate(retailer.name, templateId, data).then((result) => {
        if (result) {
          setTemplateExists(true);
          setShowMessage(true);
          setDisabled(true);
          setShowLoading(false);
        }
      });
    }
  };

  const syncNativeTemplate = () => {
    setShowSyncLoading(true);
    ApiRequest({
      retailer: retailer.name,
      service: "gam",
      call: "getNativeStyle",
      nativeId: retailer.templates[id].styleId,
    }).then(
      (results) => {
        const { htmlSnippet, cssSnippet } = results.result[0];
        const data = { ...templateData, htmlSnippet, cssSnippet };
        updateNativeTemplate(retailer.name, templateId, data).then(() => {
          setShowSyncLoading(false);
          setShowSyncMessage(
            "Template has been synced with Native template from Ad Manager"
          );
        });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const syncCustomTemplate = () => {
    setShowSyncLoading(true);
    const data = { ...templateData, htmlSnippet: customSnippet, selectors };
    updateNativeTemplate(retailer.name, templateId, data).then(() => {
      setShowSyncLoading(false);
      setShowSyncMessage(
        "Template has been synced with Custom template from Ad Manager"
      );
    });
  };

  return (
    <>
      <Segment>
        <Form onSubmit={handleSubmit} className="selector-form">
          <Header as="h3">Icon selectors</Header>
          <Button
            icon
            size="mini"
            positive
            onClick={() => addSelector()}
            type="button"
          >
            <Icon name="plus" />
          </Button>
          {selectors.map((selector, index) => (
            <Form.Group key={index}>
              <Form.Field>
                <Form.Input
                  label="Icon"
                  name="icon"
                  value={selector.icon}
                  onChange={(e) => handleChange(e, index)}
                />
              </Form.Field>
              <Form.Field>
                <Form.Input
                  label="Name"
                  name="title"
                  value={selector.title}
                  onChange={(e) => handleChange(e, index)}
                />
              </Form.Field>
              <Form.Field>
                <Form.Input
                  label="Width"
                  name="width"
                  value={selector.width}
                  onChange={(e) => handleChange(e, index)}
                />
              </Form.Field>
              <Form.Field>
                <label>&nbsp;</label>
                <Button
                  type="button"
                  onClick={() => removeSelector(index)}
                  icon
                  size="tiny"
                  color="red"
                >
                  <Icon name="trash" />
                </Button>
              </Form.Field>
            </Form.Group>
          ))}
          {showMessage && (
            <Message
              content="Icon selectors have been updated"
              positive
              onDismiss={() => setShowMessage(false)}
            />
          )}
          <Button
            positive
            size="mini"
            disabled={disabled}
            loading={showLoading}
          >
            Submit
          </Button>
        </Form>
      </Segment>
      {service === "gam" &&
        (templateType === "native" || templateType === "custom") && (
          <Segment>
            <Header as="h3">Sync template</Header>
            {showSyncMessage && (
              <Message
                content={showSyncMessage}
                positive
                onDismiss={() => setShowSyncMessage(null)}
              />
            )}
            <Button
              onClick={() =>
                isNative ? syncNativeTemplate() : syncCustomTemplate()
              }
              positive
              size="mini"
              loading={showSyncLoading}
            >
              Sync
            </Button>
          </Segment>
        )}
    </>
  );
};

export default Selectors;
